import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef, type ReactNode } from 'react';

import { CheckIcon } from '@air/design-icons';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const selectItem = tailwindVariants({
  base: 'group/select-item flex shrink-0 cursor-pointer radix-disabled:cursor-not-allowed items-center gap-1 rounded-4 radix-disabled:bg-transparent radix-highlighted:ads:bg-hover-subtle radix-highlighted:bg-gray-4 px-1.5 text-inherit radix-disabled:opacity-50 outline-none hover:ads:bg-hover-subtle hover:bg-gray-4 radix-disabled:hover:ads:bg-transparent disabled:cursor-not-allowed',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'min-h-[36px] text-16',
      small: 'min-h-[32px] text-14',
    },
  },
});

export type SelectItemVariants = VariantProps<typeof selectItem>;

export type SelectItemProps = Omit<RadixSelect.SelectItemProps, 'prefix'> &
  SelectItemVariants & {
    prefix?: ReactNode;
  };

export const SelectItem = forwardRef<HTMLDivElement, SelectItemProps>(
  ({ children, className, prefix, size, ...restOfProps }, forwardedRef) => {
    return (
      <RadixSelect.Item
        className={selectItem({ class: className, size })}
        data-testid="SELECT_ITEM"
        {...restOfProps}
        ref={forwardedRef}
      >
        {prefix ? <div className="flex shrink-0 items-center justify-center">{prefix}</div> : null}

        <span className="grow">
          <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
        </span>

        <RadixSelect.ItemIndicator className="shrink-0">
          <CheckIcon className="ads:text-icon-primary text-blue-9" size="sm" />
        </RadixSelect.ItemIndicator>
      </RadixSelect.Item>
    );
  },
);

SelectItem.displayName = 'SelectItem';
